/**
 * @fileoverview Fan routes (protected routes for fans/spectators).
 * @package PlayItNow
 * @module apps/front/routes/fan
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */

import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { ProtectedRoute } from '@/components/ProtectedRoute'

// Lazy load pages for code splitting
const SettingsPage = lazy(() =>
  import('../pages/SettingsPage').then((m) => ({ default: m.SettingsPage })),
)

/**
 * @summary Fan routes.
 * Includes protected routes for fans/spectators.
 */
export const fanRoutes = [
  /* Fan settings */
  <Route
    key="fan-settings"
    path="/settings"
    element={
      <ProtectedRoute>
        <SettingsPage />
      </ProtectedRoute>
    }
  />,
]
